import { DefaultTheme } from 'styled-components'

const theme: DefaultTheme = {
  colors: {
    primary: '#266059', // eden (green)
    secondary: '#f3e9e1', // sauvignon
    tertiary: '#994837', // mojo
    highlight: '#ad796c',
    offWhite: '#f7f7f7', // gallery (white)
    text: '#2a2a2a', // jaguar (black)
    muted: '#c4c4c4', // grey
    neutral: '#f1f1f1', // light grey
    focus: '-webkit-focus-ring-color', // mojo
    softContrast: '#404040', // heathered black
  },
  fonts: {
    primary: `'Maven Pro', sans-serif`,
    secondary: `'Cormorant', serif`,
    tertiary: `'Montserrat', sans-serif`,
  },
}

export default theme
